const initState = {
  isRejecting: false,
  error: null,
}

export default initState
